/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>重新储值商家管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.varName" placeholder="输入商家名称"></el-input>
      </el-form-item>
	  <el-form-item label="门店编号">
	    <el-input size="small" v-model="formInline.mchCode" placeholder="输入门店编号"></el-input>
	  </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="mchId" label="id" width="150">
      </el-table-column>
      <el-table-column prop="name" label="商家名称" width="200">
      </el-table-column>
      <el-table-column prop="cityName" label="城市">
      </el-table-column>
      <el-table-column prop="mchCode" label="门店编号">
      </el-table-column>
      <el-table-column prop="addr" label="餐厅地址" width="200">
      </el-table-column>
      <el-table-column prop="rateBase" label="基础折扣">
      </el-table-column>
      <el-table-column prop="rateSale" label="销售折扣">
      </el-table-column>
      <el-table-column prop="ver" label=" 版本号">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="340">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row.mchId,3)">重储</el-button>
          <el-button size="mini" @click="handleEdit(scope.row.mchId,4)">续储</el-button>

          <el-button size="mini" @click="handleEdit(scope.row.mchId,1)">修改商家储值信息</el-button>
          <el-button size="mini" @click="handleEdit(scope.row.mchId,2)">修改银行卡</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
  import {
    getMerchantListPage,
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        editForm: {
          deptId: '',
          deptName: '',
          deptNo: '',
          token: localStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          varLable: '',
          varName: '',
		   mchCode:'',
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter, type) {
        this.loading = true
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": parameter.page,
          "pageSize": parameter.limit,
          "name": parameter.varName,
		  "mchCode": parameter.mchCode,
		  
          state: 1
        }
        getMerchantListPage(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline, 1)
      },
      //显示编辑界面
      handleEdit: function(row, type) {
        if (type == 1) {
          this.$router.push({
            name: '修改商家储值信息',
            query: {
              id: row
            }
          })
        } else if (type == 2) {
          this.$router.push({
            name: '修改银行卡',
            query: {
              id: row
            }
          })
        } else if (type == 3) {
          this.$router.push({
            name: '重储',
            query: {
              id: row
            }
          })
        } else if (type == 4) {
          this.$router.push({
            name: '续储',
            query: {
              id: row
            }
          })
        }
      },



    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/pay/heavyStorageList.vue